<template>
  <svg
    width="81"
    height="24"
    viewBox="0 0 81 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M72.9234 4.65189C62.8111 3.89647 59.8667 9.23589 59.1113 14.3178C57.7893 23.357 65.4121 23.7776 65.4121 23.7776C65.4121 23.7776 69.7901 24.4558 73.2667 23.4428C77.6962 22.1552 80.0397 18.6872 80.6406 14.3264C81.4819 8.2487 79.1641 5.11544 72.9234 4.65189ZM73.9106 14.3178C73.4556 17.6141 72.2538 21.5457 68.9145 21.5715C65.6096 21.5028 65.4036 17.6399 65.8585 14.3178C66.3135 10.9871 67.5067 7.02974 70.9318 6.85805C74.4943 6.79796 74.3655 11.0214 73.9106 14.3178Z"
      fill="white"
    />
    <path
      d="M9.79465 4.91905L2.74697 4.90189L0 23.504H7.04768L9.45128 7.27114C9.66589 7.27114 9.94058 7.20247 10.3269 7.12521C16.6277 5.97492 16.602 8.7133 16.3788 10.2327L14.4302 23.504H21.4778L23.4608 10.1469C23.7527 7.83771 22.7054 3.26229 9.79465 4.91905Z"
      fill="white"
    />
    <path
      d="M26.8258 10.9893L24.9544 23.5309H32.0021L33.8821 10.9893H26.8258Z"
      fill="white"
    />
    <path
      d="M34.792 4.56738H27.7358L27.1005 8.92819H34.1482L34.792 4.56738Z"
      fill="white"
    />
    <path
      d="M52.3297 12.7906C53.6689 12.4214 55.4372 11.9407 55.7634 9.63155L56.536 4.9102H49.454L48.8016 9.11649C48.8016 9.11649 48.3896 11.8635 44.7241 11.5888L46.4066 0H39.3589L35.8909 23.5209H42.9729L44.2605 15.0139C44.5095 14.9967 44.561 14.9881 44.8958 14.9452C50.8532 14.0353 49.8661 18.0355 49.8661 18.0355L49.0506 23.5209H56.1326L56.6734 19.5292C57.343 15.074 55.1368 13.3657 52.3297 12.7906Z"
      fill="white"
    />
  </svg>
</template>
<script>
export default {
  name: "niko-icon",
};
</script>
